// this is aliased in webpack config based on server/client build
// server和client的要分别注意对登录态的处理
// import { createAPI } from 'create-api'

import axios from 'axios';
import * as rootUrl from './urlConfig';
import { convertToFiveMillion } from '../util/common'

const requestConfig = require('../../bin/config');
const apiDomain = process.env.VUE_ENV === 'server' ? requestConfig.apiDomain : '';
const apiYinniDomain = process.env.VUE_ENV === 'server' ? requestConfig.apiYinniDomain : '';

const language = 'id-id'; // 印尼语

export function fetchArticleBody (articleId) {
    let id = articleId.match(/^\d+/g);
    return axios.get(`${apiDomain}/m/v2/article/body/${id ? id[0] : ''}?plat=m&language=${language}`).then((response) => {
        return response.data;
    }).catch(function (error) {
        return (error);
    });
}

export function fetchOddsChange (options) {
    const url = `${apiDomain}/data/odds/detail/${options.id}?companyId=${options.companyId}&type=${options.type}&rate=${options.rate}&language=${language}`;
    // const url = 'http://beta-api.allfootballapp.com/data/odds/detail/50956312?companyId=1183&type=euro&rate=Decimal';
    return axios.get(url).then(response => {
        return response.data;
    }).catch(function (error) {
        return (error);
    });
}

// 初始化
export const appInitApi = {
    // 新闻菜单
    menusApi () {
        let _url = rootUrl.menuListHome;
        return axios.get(_url).then((response) => response.data);
    },
    // 比赛菜单
    matchMenusApi () {
        let _url = rootUrl.menuListMatch;
        return axios.get(_url).then((response) => response.data);
    },
    // stats菜单
    statsMenusApi() {
        const url = rootUrl.menuListStats
        return axios.get(url).then((response) => response.data);
    },
    // video菜单
    videoMenusApi () {
        let _url = rootUrl.menuListVideo;
        return axios.get(_url).then((response) => response.data);
    }
};
// 新闻列表
export const newsApi = {
    getNewsList (_url) {
        return axios.get(_url).then((response) => response.data);
    }
};

// 比赛列表
export const matchApi = {
    getMatchList (_url) {
        return axios.get(_url).then((response) => response.data);
    }
};
// 比赛详情
export const matchDetailApi = {
    // 头部比赛信息
    fetchMatchDetailFormation (matchId) {
        const url = `${apiDomain}/m/data/detail/match/${matchId}?plat=m&language=${language}`;
        return axios.get(url).then(response => response.data);
    },
    // overview
    fetchMatchOverviewFormation (matchId) {
        const url = `${apiYinniDomain}/app/detail/overview?id=${matchId}&language=${language}`;
        return axios.get(url).then(response => response.data);
    },
    // analysis
    fetchMatchAnalysisFormation (matchId, locale, isJSON) {
        const url = `${apiDomain}/data/new/pre_analysis/${matchId}?isJSON=${isJSON}&language=${locale}`;
        return axios.get(url).then(response => response.data);
    },
    // odds
    fetchMatchOddsEuro (matchId) {
        const url = `${apiDomain}/data/odds_data/summary/euro/${matchId}&language=${language}`;
        return axios.get(url).then(response => response.data);
    },
    fetchMatchOddsAsia (matchId) {
        const url = `${apiDomain}/data/odds_data/summary/asia/${matchId}&language=${language}`;
        return axios.get(url).then(response => response.data);
    },
    fetchMatchOddsOverUnder (matchId) {
        const url = `${apiDomain}/data/odds_data/summary/over_under/${matchId}&language=${language}`;
        return axios.get(url).then(response => response.data);
    },
    // live
    fetchMatchLiveFormation(matchId) {
        const cId= convertToFiveMillion(matchId)
        const url = `${apiYinniDomain}/app/live/list?match_id=${cId}&language=${language}`

        return axios.get(url).then(response =>  response.data)
    },
};
// stats列表
export const statsApi = {
    getStatsList (_url) {
        return axios.get(_url).then((response) => response.data);
    }
};

export const videoApi = {
    getVideoList (_url) {
        return axios.get(_url).then((response) => response.data);
    }
};

// tweet文章落地页

export const tweetApi = {
    fetchTweetArticleInfo (_url) {
        console.log('url====', _url)
        return axios.get(_url).then((response) => {
            return response.data;
        });
    }
};



// WEBPACK FOOTER //
// ./src/api/index.js